module.exports = __webpack_public_path__ + "static/media/pause_icon_white.fc889eda.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/pause_icon_white.svg
// module id = 834
// module chunks = 0